(function(){
    var collections = {
		 shows: Backbone.Collection.extend({
			initialize:function(models, options){
			    this.term = options.term;
		    }
		 })
		,episodes : Backbone.Collection.extend({
			initialize:function(models, options){
			    this.term = options.term;
		    }
		 })
	}

/* 
    API

    Use: Backbone.Radio.channel('entities').request('search',term)
    
    This entity is unusual in that we split the return into two different collections
    and return that as an array of collections. 
    
    $.when( Backbone.Radio.channel('entities').request('search',term) )
        .done(function(data){ 
            console.log('shows',data.shows) 
            console.log('episodes',data.episodes) 
        })
*/ 
    var api = Backbone.Radio.channel('entities');

    //get a collection
    api.reply('search',function(term){
	    var defer = $.Deferred();
	    
	    $.getJSON(APP_CONFIG.MEDIA_API_ROOT+"search/"+term, function(response){
		    collections.shows = new collections.shows(response.show_results,{term:term});
			collections.episodes = new collections.episodes(response.episode_results,{term:term});
			defer.resolve(collections);
		});
	    
        return defer.promise();
    })

})();